import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService, pdfService } from '_services';
import { ActionNames, Errors } from '_constants'
import { patientActions } from './patient.actions';

export const notesReqApprovalActions = {
    load: () => dispatch => {
        dispatch(notesReqApprovalActions.loadRequest());
        messageCenterService.loadNotesRequiringApproval()
            .then(
                messages => {
                    dispatch(notesReqApprovalActions.loadSuccess(messages));
                },
                error => {
                    dispatch(notesReqApprovalActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_LOAD_FAILURE),

    approveAll: (noteIds) => dispatch => {
        dispatch(notesReqApprovalActions.approveAllRequest());
        messageCenterService.approveAllNotesRequiringApproval(noteIds)
            .then(
                messages => {
                    dispatch(notesReqApprovalActions.approveAllSuccess(messages));
                },
                error => {
                    dispatch(notesReqApprovalActions.approveAllFailure({ noteIds: noteIds, error: error }));
                    dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_APPROVE_ALL_FAILURE));
                }
            );
    },
    approveAllRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_ALL_REQUEST),
    approveAllSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_ALL_SUCCESS),
    approveAllFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_ALL_FAILURE),

    setSelectedMessage: createAction(ActionNames.NOTES_REQ_APPROVAL_SET_SELECTED_MESSAGE),

    changeSelection: (noteId) => (dispatch, getState) => {
        dispatch(notesReqApprovalActions.setSelectedMessage({ noteId }));

        dispatch(patientActions.openAl(getState().entities.notesReqApproval[noteId].epno, getState().entities.notesReqApproval[noteId].ptno));

        
        if (!getState().entities.notesReqApproval[noteId].isRead) {
            dispatch(notesReqApprovalActions.markReadRequest({ noteId }));

            messageCenterService.markRead(noteId)
                .then(
                    () => { dispatch(notesReqApprovalActions.markReadSuccess(noteId)) }
                    ,
                    error => {
                        dispatch(notesReqApprovalActions.markReadFailure({ noteId: noteId, error: error }));
                        dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_MARK_READ_FAILURE));
                    }
                );
        }

        dispatch(notesReqApprovalActions.openPdf(noteId));
    },
    markReadRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_MARK_READ_FAILURE),


    approve: (noteId) => dispatch => {
        dispatch(notesReqApprovalActions.approveRequest({ noteId }));

        messageCenterService.approveNoteRequiringApproval(noteId)
            .then(
                () => { dispatch(notesReqApprovalActions.approveSuccess(noteId)) }
                ,
                error => {
                    dispatch(notesReqApprovalActions.approveFailure({ noteId: noteId, error: error }));
                    dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_APPROVE_FAILURE));
                }
            );
    },
    approveRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_REQUEST),
    approveSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_SUCCESS),
    approveFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_APPROVE_FAILURE),

    reject: (noteId, rejectReason) => dispatch => {
        dispatch(notesReqApprovalActions.rejectRequest({ noteId }));

        messageCenterService.rejectNoteRequiringApproval(noteId, rejectReason)
            .then(
                () => { dispatch(notesReqApprovalActions.rejectSuccess(noteId)) }
                ,
                error => {
                    dispatch(notesReqApprovalActions.rejectFailure({ noteId: noteId, error: error }));
                    dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_REJECT_FAILURE));
                }
            );
    },
    rejectRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_REJECT_REQUEST),
    rejectSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_REJECT_SUCCESS),
    rejectFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_REJECT_FAILURE),

    toggleReject: createAction(ActionNames.NOTES_REQ_APPROVAL_TOGGLE_REJECT),


    openPdf: (noteId) => (dispatch, getState) => {
        dispatch(notesReqApprovalActions.openPdfRequest());
        // if the state does not already contain the patient
        if (!getState().entities.pdfs.hasOwnProperty(noteId)) {
            dispatch(notesReqApprovalActions.loadPdfRequest());
            pdfService.load(noteId)
                .then(
                    noteData => {
                        dispatch(notesReqApprovalActions.loadPdfSuccess(noteData));
                        dispatch(notesReqApprovalActions.openPdfSuccess(noteId));
                    },
                    error => {
                        dispatch(notesReqApprovalActions.loadPdfFailure({ noteId: noteId, error: error }));
                        dispatch(notesReqApprovalActions.openPdfFailure({ noteId: noteId, error: error }));
                        dispatch(alertActions.error(Errors.NOTES_REQ_APPROVAL_PDF_OPEN_FAILURE));
                    }
                );
        } else {
            dispatch(notesReqApprovalActions.openPdfSuccess(noteId));
        }
    },
    openPdfRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_OPEN_REQUEST),
    openPdfSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_OPEN_SUCCESS),
    openPdfFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_OPEN_FAILURE),

    loadPdfRequest: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_LOAD_REQUEST),
    loadPdfSuccess: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_LOAD_SUCCESS),
    loadPdfFailure: createAction(ActionNames.NOTES_REQ_APPROVAL_PDF_LOAD_FAILURE),
}
